// Verify methods should return true if data is valid and false otherwise

import React from "react";

export const verifyName = (name: string): boolean => {
    // In contrast to other verify methods if this pattern is matched we want to reject it
    // While in practice it amounts to an ugly !(!/^[ ]*$/gm.test(name)) in our use cases, this allows all verify methods to behave the same

    return !/^[ ]*$/gm.test(name);

}

export const verifyPhone = (phone: string): boolean => {
    return /^\d{4,15}$/im.test(replaceAll(phone, /[+-\s().]/g, ""));
    }

export const verifyZip = (zip: string): boolean => {
    return /^[a-z0-9][a-z0-9 -]+$/im.test(zip) && /\d/im.test(zip);
}

type InputListener = (event: React.ChangeEvent<HTMLInputElement>) => void;
//Factory for listeners to remove spaces after input is entered
export const checkTrailingSpace = (callBackFn: InputListener) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target as HTMLInputElement;
        if (input.value.endsWith(" ")) {
            input.value = input.value.trim();
        }
        callBackFn(event);
    }
}

/**
 * Finds and replaces all instances of a substring
 * @param str The string to search.
 * @param find The substring to search for.
 * @param replace The substring to replace 'find'
 * @returns str.replaceAll(find, replace)
 */
export function replaceAll(str: string, find: RegExp | string, replace: string) {
	return str.replace(find, replace);
}
